module.exports = __webpack_public_path__ + "static/media/profile_verified_icon.d6da281d.png";